import Npv from './Npv';

const LoansDefaultedChart = () => <Npv report="MonthlyNpvByLedger" desc="Monthly NPV By Ledger" />;

export default LoansDefaultedChart;
